const enterpriseIds = {
  aluru_akash: "aluru.akash",
  uma_rani_battu: "uma.rani.battu",
  jeevadharani_ramanan: "jeevadharani.ramanan",
  reshmi_haridas_m: "reshmi.haridas.m",
  ankur_e_mishra: "ankur.e.mishra",
  aayushi_bharti: "aayushi.bharti",
  arpita_m_singh: "arpita.m.singh",
  jb_bhardwaj: "j.b.bhardwaj",
  varsha_a_tyagi: "varsha.a.tyagi",
  h_srinivasan: "h.srinivasan",
  atci_portaldevelopment: "ATCI.LKM.LIS.PORTALDEVELOPMENT",
  enbridge_talentAcademy: "LKM.EnbridgeTalentAcademy",
  LKM_TalentAcademy_Team: "LKMTalentAcademyTeam",
};
const domain = "accenture.com";
const dsdevdomain = "ds.dev.accenture.com";
const LKM_TalentAcademy_Team_mail = `${enterpriseIds.LKM_TalentAcademy_Team}@${domain}`;
const enbridge_talentAcademy_mail = `${enterpriseIds.enbridge_talentAcademy}@${domain}`;
const atciPortaldevelopment = `${enterpriseIds.atci_portaldevelopment}@${domain}`;

const aluruakash = `${enterpriseIds.aluru_akash}@${domain}`;
const dsdevaluruakash = `${enterpriseIds.aluru_akash}@${dsdevdomain}`;
const umaranibattu = `${enterpriseIds.uma_rani_battu}@${domain}`;
const dsdevumaranibattu = `${enterpriseIds.uma_rani_battu}@${dsdevdomain}`;
const jeevadharaniramanan = `${enterpriseIds.jeevadharani_ramanan}@${domain}`;
const reshmiharidasm = `${enterpriseIds.reshmi_haridas_m}@${domain}`;
const dsdevreshmiharidasm = `${enterpriseIds.reshmi_haridas_m}@${dsdevdomain}`;
const ankuremishra = `${enterpriseIds.ankur_e_mishra}@${domain}`;
const dsdevankuremishra = `${enterpriseIds.ankur_e_mishra}@${dsdevdomain}`;
const aayushibharti = `${enterpriseIds.aayushi_bharti}@${domain}`;
const dsdevaayushibharti = `${enterpriseIds.aayushi_bharti}@${dsdevdomain}`;
const arpitamsingh = `${enterpriseIds.arpita_m_singh}@${domain}`;
const jbbhardwaj = `${enterpriseIds.jb_bhardwaj}@${domain}`;
const varshaatyagi = `${enterpriseIds.varsha_a_tyagi}@${domain}`;
const hsrinivasan = `${enterpriseIds.h_srinivasan}@${domain}`;

export default {
  atciPortaldevelopment,
  aluruakash,
  dsdevaluruakash,
  umaranibattu,
  dsdevumaranibattu,
  jeevadharaniramanan,
  reshmiharidasm,
  dsdevreshmiharidasm,
  ankuremishra,
  dsdevankuremishra,
  aayushibharti,
  dsdevaayushibharti,
  arpitamsingh,
  jbbhardwaj,
  varshaatyagi,
  hsrinivasan,
  enbridge_talentAcademy_mail,
  LKM_TalentAcademy_Team_mail,
};
